// Suite des traductions Postinity — en-tête page de préparation, onglets, activations, bannières.
// Fusionné dans "po" au niveau de i18n/index.js.

const fr = {
  lc_title: "Je prépare ma cérémonie",
  lc_by: "By Postinity",
  lc_intro: "Avancez pas à pas, à votre rythme : validez chaque étape pour la faire passer au vert ; elle reste en doré tant qu'elle n'est pas validée. Tout reste modifiable à tout moment.",
  lc_private: "Espace 100 % privé & sécurisé, visible de vous seul tant que la bougie n'est pas publiée.",
  lc_save_anytime: "Vous pouvez tout enregistrer et revenir le compléter à tout moment.",
  lc_act_garantes_on: "Garants activés ✓",
  lc_act_garantes_off: "Activer mes garants",
  lc_act_ceremony_on: "Cérémonie activée ✓",
  lc_act_ceremony_off: "Activer ma cérémonie",
  tab_ceremonie: "Ma cérémonie",
  tab_message: "Message perso",
  tab_bougie: "Ma bougie",
  tab_garants: "Mes garants",
  lc_published: "Cet hommage est déjà publié.",
  lc_see_candle: "Voir la bougie",
  all_done_title: "Bravo, tout est prêt 🕯️",
  all_done_desc: "Vous avez pris soin de chaque étape. Vous pouvez tout modifier à tout moment — et publier quand vous le souhaitez, depuis l'onglet « Mes garants ».",
  free_badge: "GRATUIT",
};
const en = {
  lc_title: "I prepare my ceremony",
  lc_by: "By Postinity",
  lc_intro: "Move forward step by step, at your own pace: validate each step to turn it green; it stays golden until validated. Everything can be changed at any time.",
  lc_private: "100% private & secure space, visible only to you until the candle is published.",
  lc_save_anytime: "You can save everything and come back to complete it anytime.",
  lc_act_garantes_on: "Guardians activated ✓",
  lc_act_garantes_off: "Activate my guardians",
  lc_act_ceremony_on: "Ceremony activated ✓",
  lc_act_ceremony_off: "Activate my ceremony",
  tab_ceremonie: "My ceremony",
  tab_message: "Personal message",
  tab_bougie: "My candle",
  tab_garants: "My guardians",
  lc_published: "This tribute is already published.",
  lc_see_candle: "View the candle",
  all_done_title: "Well done, everything is ready 🕯️",
  all_done_desc: "You have taken care of every step. You can change everything at any time — and publish whenever you wish, from the “My guardians” tab.",
  free_badge: "FREE",
};
const es = {
  lc_title: "Preparo mi ceremonia",
  lc_by: "By Postinity",
  lc_intro: "Avanza paso a paso, a tu ritmo: valida cada etapa para ponerla en verde; permanece en dorado hasta validarla. Todo se puede modificar en cualquier momento.",
  lc_private: "Espacio 100 % privado y seguro, visible solo para ti hasta que se publique la vela.",
  lc_save_anytime: "Puedes guardar todo y volver a completarlo en cualquier momento.",
  lc_act_garantes_on: "Garantes activados ✓",
  lc_act_garantes_off: "Activar mis garantes",
  lc_act_ceremony_on: "Ceremonia activada ✓",
  lc_act_ceremony_off: "Activar mi ceremonia",
  tab_ceremonie: "Mi ceremonia",
  tab_message: "Mensaje personal",
  tab_bougie: "Mi vela",
  tab_garants: "Mis garantes",
  lc_published: "Este homenaje ya está publicado.",
  lc_see_candle: "Ver la vela",
  all_done_title: "¡Bravo, todo está listo! 🕯️",
  all_done_desc: "Has cuidado cada etapa. Puedes modificar todo en cualquier momento — y publicar cuando quieras, desde la pestaña «Mis garantes».",
  free_badge: "GRATIS",
};
const de = {
  lc_title: "Ich bereite meine Zeremonie vor",
  lc_by: "By Postinity",
  lc_intro: "Gehen Sie Schritt für Schritt in Ihrem Tempo vor: Bestätigen Sie jeden Schritt, damit er grün wird; er bleibt golden, bis er bestätigt ist. Alles bleibt jederzeit änderbar.",
  lc_private: "100 % privater & sicherer Bereich, nur für Sie sichtbar, bis die Kerze veröffentlicht wird.",
  lc_save_anytime: "Sie können alles speichern und jederzeit zurückkommen, um es zu vervollständigen.",
  lc_act_garantes_on: "Bürgen aktiviert ✓",
  lc_act_garantes_off: "Meine Bürgen aktivieren",
  lc_act_ceremony_on: "Zeremonie aktiviert ✓",
  lc_act_ceremony_off: "Meine Zeremonie aktivieren",
  tab_ceremonie: "Meine Zeremonie",
  tab_message: "Persönliche Nachricht",
  tab_bougie: "Meine Kerze",
  tab_garants: "Meine Bürgen",
  lc_published: "Diese Hommage ist bereits veröffentlicht.",
  lc_see_candle: "Kerze ansehen",
  all_done_title: "Bravo, alles ist bereit 🕯️",
  all_done_desc: "Sie haben sich um jeden Schritt gekümmert. Sie können jederzeit alles ändern — und veröffentlichen, wann Sie möchten, über den Reiter „Meine Bürgen“.",
  free_badge: "GRATIS",
};
const it = {
  lc_title: "Preparo la mia cerimonia",
  lc_by: "By Postinity",
  lc_intro: "Procedi passo dopo passo, al tuo ritmo: convalida ogni fase per farla diventare verde; resta dorata finché non è convalidata. Tutto è modificabile in qualsiasi momento.",
  lc_private: "Spazio 100% privato e sicuro, visibile solo a te finché la candela non è pubblicata.",
  lc_save_anytime: "Puoi salvare tutto e tornare a completarlo in qualsiasi momento.",
  lc_act_garantes_on: "Garanti attivati ✓",
  lc_act_garantes_off: "Attiva i miei garanti",
  lc_act_ceremony_on: "Cerimonia attivata ✓",
  lc_act_ceremony_off: "Attiva la mia cerimonia",
  tab_ceremonie: "La mia cerimonia",
  tab_message: "Messaggio personale",
  tab_bougie: "La mia candela",
  tab_garants: "I miei garanti",
  lc_published: "Questo omaggio è già pubblicato.",
  lc_see_candle: "Vedi la candela",
  all_done_title: "Bravo, è tutto pronto 🕯️",
  all_done_desc: "Ti sei preso cura di ogni fase. Puoi modificare tutto in qualsiasi momento — e pubblicare quando vuoi, dalla scheda «I miei garanti».",
  free_badge: "GRATIS",
};
const pl = {
  lc_title: "Przygotowuję moją ceremonię",
  lc_by: "By Postinity",
  lc_intro: "Idź krok po kroku, we własnym tempie: zatwierdź każdy etap, aby stał się zielony; pozostaje złoty, dopóki nie zostanie zatwierdzony. Wszystko można zmienić w każdej chwili.",
  lc_private: "Przestrzeń w 100% prywatna i bezpieczna, widoczna tylko dla Ciebie, dopóki świeca nie zostanie opublikowana.",
  lc_save_anytime: "Możesz wszystko zapisać i wrócić, aby uzupełnić w dowolnej chwili.",
  lc_act_garantes_on: "Gwaranci aktywowani ✓",
  lc_act_garantes_off: "Aktywuj moich gwarantów",
  lc_act_ceremony_on: "Ceremonia aktywowana ✓",
  lc_act_ceremony_off: "Aktywuj moją ceremonię",
  tab_ceremonie: "Moja ceremonia",
  tab_message: "Wiadomość osobista",
  tab_bougie: "Moja świeca",
  tab_garants: "Moi gwaranci",
  lc_published: "Ten hołd jest już opublikowany.",
  lc_see_candle: "Zobacz świecę",
  all_done_title: "Brawo, wszystko gotowe 🕯️",
  all_done_desc: "Zadbałeś o każdy etap. Możesz wszystko zmienić w dowolnej chwili — i opublikować, kiedy zechcesz, z zakładki „Moi gwaranci”.",
  free_badge: "ZA DARMO",
};
const fil = {
  lc_title: "Inihahanda ko ang aking seremonya",
  lc_by: "By Postinity",
  lc_intro: "Sumulong nang paunti-unti, sa sarili mong bilis: patunayan ang bawat hakbang para maging berde; nananatili itong ginto hanggang mapatunayan. Mababago ang lahat anumang oras.",
  lc_private: "100% pribado at ligtas na espasyo, nakikita mo lang hanggang mailathala ang kandila.",
  lc_save_anytime: "Maaari mong i-save ang lahat at bumalik para kumpletuhin anumang oras.",
  lc_act_garantes_on: "Naka-activate ang mga tagapangalaga ✓",
  lc_act_garantes_off: "I-activate ang aking mga tagapangalaga",
  lc_act_ceremony_on: "Naka-activate ang seremonya ✓",
  lc_act_ceremony_off: "I-activate ang aking seremonya",
  tab_ceremonie: "Aking seremonya",
  tab_message: "Personal na mensahe",
  tab_bougie: "Aking kandila",
  tab_garants: "Aking mga tagapangalaga",
  lc_published: "Nailathala na ang parangal na ito.",
  lc_see_candle: "Tingnan ang kandila",
  all_done_title: "Magaling, handa na ang lahat 🕯️",
  all_done_desc: "Inalagaan mo ang bawat hakbang. Mababago mo ang lahat anumang oras — at mailalathala kailan mo gusto, mula sa tab na “Aking mga tagapangalaga”.",
  free_badge: "LIBRE",
};
const ru = {
  lc_title: "Я готовлю свою церемонию",
  lc_by: "By Postinity",
  lc_intro: "Продвигайтесь шаг за шагом, в своём темпе: подтвердите каждый этап, чтобы он стал зелёным; он остаётся золотым, пока не подтверждён. Всё можно изменить в любой момент.",
  lc_private: "Пространство на 100% приватное и защищённое, видно только вам, пока свеча не опубликована.",
  lc_save_anytime: "Вы можете всё сохранить и вернуться, чтобы дополнить, в любой момент.",
  lc_act_garantes_on: "Поручители активированы ✓",
  lc_act_garantes_off: "Активировать поручителей",
  lc_act_ceremony_on: "Церемония активирована ✓",
  lc_act_ceremony_off: "Активировать церемонию",
  tab_ceremonie: "Моя церемония",
  tab_message: "Личное послание",
  tab_bougie: "Моя свеча",
  tab_garants: "Мои поручители",
  lc_published: "Эта дань памяти уже опубликована.",
  lc_see_candle: "Посмотреть свечу",
  all_done_title: "Отлично, всё готово 🕯️",
  all_done_desc: "Вы позаботились о каждом этапе. Вы можете всё изменить в любой момент — и опубликовать, когда захотите, во вкладке «Мои поручители».",
  free_badge: "БЕСПЛАТНО",
};
const el = {
  lc_title: "Ετοιμάζω την τελετή μου",
  lc_by: "By Postinity",
  lc_intro: "Προχωρήστε βήμα-βήμα, με τον δικό σας ρυθμό: επικυρώστε κάθε βήμα για να γίνει πράσινο· παραμένει χρυσό μέχρι να επικυρωθεί. Όλα αλλάζουν ανά πάσα στιγμή.",
  lc_private: "Χώρος 100% ιδιωτικός & ασφαλής, ορατός μόνο σε εσάς μέχρι να δημοσιευτεί το κερί.",
  lc_save_anytime: "Μπορείτε να αποθηκεύσετε τα πάντα και να επιστρέψετε να τα ολοκληρώσετε οποτεδήποτε.",
  lc_act_garantes_on: "Εγγυητές ενεργοποιήθηκαν ✓",
  lc_act_garantes_off: "Ενεργοποίηση εγγυητών",
  lc_act_ceremony_on: "Η τελετή ενεργοποιήθηκε ✓",
  lc_act_ceremony_off: "Ενεργοποίηση τελετής",
  tab_ceremonie: "Η τελετή μου",
  tab_message: "Προσωπικό μήνυμα",
  tab_bougie: "Το κερί μου",
  tab_garants: "Οι εγγυητές μου",
  lc_published: "Αυτός ο φόρος τιμής έχει ήδη δημοσιευτεί.",
  lc_see_candle: "Δείτε το κερί",
  all_done_title: "Μπράβο, όλα είναι έτοιμα 🕯️",
  all_done_desc: "Φροντίσατε κάθε βήμα. Μπορείτε να αλλάξετε τα πάντα ανά πάσα στιγμή — και να δημοσιεύσετε όποτε θέλετε, από την καρτέλα «Οι εγγυητές μου».",
  free_badge: "ΔΩΡΕΑΝ",
};
const hi = {
  lc_title: "मैं अपना समारोह तैयार करता/करती हूँ",
  lc_by: "By Postinity",
  lc_intro: "अपनी गति से कदम-दर-कदम आगे बढ़ें: हर चरण को हरा करने के लिए मान्य करें; मान्य होने तक यह सुनहरा रहता है। सब कुछ कभी भी बदला जा सकता है।",
  lc_private: "100% निजी और सुरक्षित स्थान, मोमबत्ती प्रकाशित होने तक केवल आपको दिखाई देता है।",
  lc_save_anytime: "आप सब कुछ सहेज सकते हैं और कभी भी पूरा करने के लिए लौट सकते हैं।",
  lc_act_garantes_on: "ज़मानतदार सक्रिय ✓",
  lc_act_garantes_off: "मेरे ज़मानतदार सक्रिय करें",
  lc_act_ceremony_on: "समारोह सक्रिय ✓",
  lc_act_ceremony_off: "मेरा समारोह सक्रिय करें",
  tab_ceremonie: "मेरा समारोह",
  tab_message: "व्यक्तिगत संदेश",
  tab_bougie: "मेरी मोमबत्ती",
  tab_garants: "मेरे ज़मानतदार",
  lc_published: "यह श्रद्धांजलि पहले ही प्रकाशित हो चुकी है।",
  lc_see_candle: "मोमबत्ती देखें",
  all_done_title: "शाबाश, सब कुछ तैयार है 🕯️",
  all_done_desc: "आपने हर चरण का ध्यान रखा। आप कभी भी सब कुछ बदल सकते हैं — और जब चाहें, «मेरे ज़मानतदार» टैब से प्रकाशित कर सकते हैं।",
  free_badge: "मुफ़्त",
};
const ja = {
  lc_title: "私のセレモニーを準備します",
  lc_by: "By Postinity",
  lc_intro: "ご自分のペースで一歩ずつ進めましょう。各ステップを確定すると緑になります。確定するまでは金色のままです。すべていつでも変更できます。",
  lc_private: "100% プライベートで安全な空間。キャンドルが公開されるまで、あなただけに表示されます。",
  lc_save_anytime: "すべて保存して、いつでも戻って続きを完成できます。",
  lc_act_garantes_on: "保証人を有効化しました ✓",
  lc_act_garantes_off: "保証人を有効化する",
  lc_act_ceremony_on: "セレモニーを有効化しました ✓",
  lc_act_ceremony_off: "セレモニーを有効化する",
  tab_ceremonie: "私のセレモニー",
  tab_message: "個人メッセージ",
  tab_bougie: "私のキャンドル",
  tab_garants: "私の保証人",
  lc_published: "この追悼はすでに公開されています。",
  lc_see_candle: "キャンドルを見る",
  all_done_title: "お見事、すべて準備できました 🕯️",
  all_done_desc: "各ステップを大切にされました。いつでもすべて変更でき、「私の保証人」タブからお好きなときに公開できます。",
  free_badge: "無料",
};
const zh = {
  lc_title: "我准备我的仪式",
  lc_by: "By Postinity",
  lc_intro: "按自己的节奏一步步推进：确认每一步使其变绿；未确认前保持金色。一切随时可修改。",
  lc_private: "100% 私密且安全的空间，在蜡烛发布前仅您可见。",
  lc_save_anytime: "您可以保存全部内容，随时回来继续完成。",
  lc_act_garantes_on: "担保人已启用 ✓",
  lc_act_garantes_off: "启用我的担保人",
  lc_act_ceremony_on: "仪式已启用 ✓",
  lc_act_ceremony_off: "启用我的仪式",
  tab_ceremonie: "我的仪式",
  tab_message: "个人留言",
  tab_bougie: "我的蜡烛",
  tab_garants: "我的担保人",
  lc_published: "此悼念已发布。",
  lc_see_candle: "查看蜡烛",
  all_done_title: "太好了，一切就绪 🕯️",
  all_done_desc: "您已用心完成每一步。您可随时修改一切 —— 并在“我的担保人”标签中随时发布。",
  free_badge: "免费",
};

export const postinity2 = { fr, en, es, de, it, pl, fil, ru, el, hi, ja, zh };
